$(function () {
  $("[data-behavior=equal-height]").exists(function ($row) {
    $row.each(function (i, row) {
      var heights = $("> div", $(row)).map(function (index, col) {
        return $(col).outerHeight();
      }).get(); // need to call get() on this to ensure this is a real array. otherwise phantom.js will fail...
      $(row).find('> div').height(Math.max.apply(null, heights));
    });
  });
});
